import { useTranslation } from 'react-i18next';

import {
    Body1,
    Button,
    Modal,
    Stack,
} from '@myphx-engineering/phx-design-system';

import { useFillPathway } from '../../../../contexts/fill/use-fill-prescription';
import { usePatientChoiceMutation } from '../../fill/common/use-patient-choice-mutation';

export type PharmacyChangeModalProps = {
    drxId: string;
    isOpen: boolean;
    toggle: () => void;
};

export const PharmacyChangeModal = ({
    drxId,
    isOpen,
    toggle,
}: PharmacyChangeModalProps) => {
    const { t } = useTranslation('lilly');
    const { pathway, originalPathway, subPathway } = useFillPathway();
    const savePatientChoices = usePatientChoiceMutation({ drxId });

    const handleChooseDifferentPharmacy = async () => {
        try {
            await savePatientChoices({
                pathway,
                originalPathway,
                subPathway,
                additionalChoices: [
                    {
                        patientChoiceKey: 'anonymous',
                        patientChoiceValue: 'true',
                    },
                ],
            });
        } catch {
            // Don't block the user from leaving if the choice fails to save.
        }

        const simplifiedProvidersUrl = `${import.meta.env.VITE_MYPHX_URL}/direct/${drxId}/providers`;

        window.location.replace(new URL(simplifiedProvidersUrl));
    };

    return (
        <Modal
            title={t('providerOffers.pharmacyChange.modal.title')}
            opened={isOpen}
            onClose={toggle}
        >
            <Stack gap="lg">
                <Stack gap="xs">
                    <Body1>
                        {t('providerOffers.pharmacyChange.modal.body1')}
                    </Body1>
                    <Body1>
                        {t('providerOffers.pharmacyChange.modal.body2')}
                    </Body1>
                </Stack>

                <Button size="lg" onClick={toggle}>
                    {t('providerOffers.pharmacyChange.modal.button.primary')}
                </Button>
                <Button
                    size="lg"
                    variant="outline"
                    onClick={handleChooseDifferentPharmacy}
                >
                    {t('providerOffers.pharmacyChange.modal.button.secondary')}
                </Button>
            </Stack>
        </Modal>
    );
};
